/*
Copyright 2023 New Vector Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE files in the repository root for full details.
*/

.link {
  display: inline-block;
  text-decoration: underline;
  color: var(--cpd-color-text-primary);
  font-weight: var(--cpd-font-weight-medium);
  border-radius: var(--cpd-radius-pill-effect);
  padding-inline: 0.25rem;
}

.link[data-kind="primary"] {
  color: var(--cpd-color-text-primary);
}

.link[data-kind="critical"] {
  color: var(--cpd-color-text-critical-primary);
}

@media (hover) {
  .link[data-kind="primary"]:hover {
    background: var(--cpd-color-gray-300);
  }

  .link[data-kind="critical"]:hover {
    background: var(--cpd-color-red-300);
  }
}

.link:active {
  color: var(--cpd-color-text-on-solid-primary);
}

.link[data-kind="primary"]:active {
  background: var(--cpd-color-text-primary);
}

.link[data-kind="critical"]:active {
  background: var(--cpd-color-text-critical-primary);
}

.link[data-size="md"] {
  font-size: var(--cpd-font-size-body-md);
}

.link[data-size="sm"] {
  font-size: var(--cpd-font-size-body-sm);
}
